import type { ClientMenuItem } from "./components/ApprovalHeader";

/**
 * The portal burger's pages (DD-025): Attività, then Menu for a client whose menus answered. A client with menus off
 * gets a 404 from the menus list, so it sees Attività only; the menus list is the one switch, with no separate flag.
 */
export function portalMenuItems(opts: {
  clientId: string;
  menusAvailable: boolean;
  labels: { tasks: string; menu: string };
  go: (path: string) => void;
}): ClientMenuItem[] {
  const { clientId, menusAvailable, labels, go } = opts;
  return [
    { label: labels.tasks, onSelect: () => go(`/client/${clientId}/tasks`) },
    ...(menusAvailable ? [{ label: labels.menu, onSelect: () => go(`/client/${clientId}/menu`) }] : []),
  ];
}
